
import { Component, Vue, Prop } from "vue-property-decorator";
import InBody from "./components/inBody/inBody.vue";
import K5 from "./components/k5/k5.vue";
import Bianxie from "./components/bianxie/bianxie.vue";
import Yundong from "./components/yundong/yundong.vue";
@Component({
  components: {
    InBody,
    K5,
    Bianxie,
    Yundong,
  },
})
export default class Name extends Vue {
  private leftTree: any = [
    {
      label: "健康体检设备",
      isOpen: true,
      children: [
        {
          parent: "健康体检设备",
          label: "InBody人体成分分析仪",
        },
        {
          parent: "健康体检设备",
          label: "K5专业体检机",
        },
        // {
        //   parent: "健康体检设备",
        //   label: "便携式体检机",
        // },
        // {
        //   parent: "健康体检设备",
        //   label: "运动心肺功能仪",
        // },
      ],
    },
  ];
  private currentTree: any = {
    parent: "健康体检设备",
    label: "InBody人体成分分析仪",
  };
  private changePart(item: any) {
    this.currentTree = item;
  }
  mounted() {}
}
